import TearSheet from './TearSheet'
import SubjectHeader from './SubjectHeader'

const abundanceEngineExports = {
  TearSheet: TearSheet,
  TSSubjectHeader: SubjectHeader
}

export default abundanceEngineExports
